<ng-container [formGroup]="form">
  <app-typeahead-field 
    formControlName="contact" 
    name="contact" 
    [label]="label"
    [isDisabled]="isDisabled"
    [dataSource$]="contacts$" 
    [isRequired]="isRequired"
    [showHighlight]="showHighlight"
    placeholder="search for contact" 
    [hasErrors]="hasErrors(contactControl)">
  </app-typeahead-field>
  <lds-form-feedback *ngIf="hasErrors(contactControl)" [control]="contactControl"
    [messages]="{ required : 'Please select a contact' }">
  </lds-form-feedback>
</ng-container>
